import {Authenticated} from './middleware'
// import CPanelSession from "@/modules/router/session";

export default [
    {
        name: 'cpanel.dashboard',
        path: 'dashboard',
        component: () => import('../../views/cpanel/dashboard'),
        meta: {
            title: '',
            back: false,
            middleware: [Authenticated]
        }
    },
    {
        name: 'cpanel.profile',
        path: 'profile',
        component: () => import ('../../views/cpanel/Profile'),
        meta: {
            title: 'Мой профиль',
            back: 'cpanel.dashboard',
            middleware: Authenticated
        }
    },
    {
        name: 'cpanel.schedule',
        path: 'schedule/:date',
        component: () => import ('../../views/cpanel/Schedule'),
        meta: {
            title: 'Бронирование',
            back: 'cpanel.dashboard',
            middleware: Authenticated
        }
    },

    // {
    //   name: 'cpanel.openLightVisits',
    //   path: 'open-light-visits',
    //   component: () => import ('../../views/cpanel/OpenLightVisits'),
    //   meta: {
    //     title: 'Открытые Light визиты',
    //     back: 'cpanel.dashboard',
    //     middleware: Authenticated,
    //     permission: 'can.manage.users'
    //   }
    // }

];
